module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_18.6d5d1ccc.mp3";